/**
 * This is the main(parent component), all the others components in this module ...
 * are child or gran-child of this component
 * @param integrationSettingsService
 * @param merchantService
 * @param messageService
 * @param integrationConstant
 * @param integrationHelperService
 * @param gettextCatalog
 * @param outletService
 */
function integrationSettings(integrationSettingsService,
                             merchantService, messageService, integrationConstant,
                             integrationHelperService, gettextCatalog, outletService, integrationUnrestService) {
    const vm = this;
    const handleError = reason => messageService.error(reason);
    const isMerchantAdminLocation = () => vm.location === integrationConstant.LOCATION.merchantAdmin.label;
    const isOutletAdminLocation = () => vm.location === integrationConstant.LOCATION.outletAdmin.label;
    const isMerchantCreationLocation = () => vm.location === integrationConstant.LOCATION.merchantCreation.label;
    const isOutletCreationLocation = () => vm.location === integrationConstant.LOCATION.outletCreation.label;
    const getTitle = () => {
        if (isMerchantAdminLocation()) {
            return 'Merchant POS Settings';
        } else {
            return 'Outlet POS Settings';
        }
    };
    const manageDisplay = () => {
        vm.visible = {
            isSubmitVisible: isMerchantAdminLocation() || isOutletAdminLocation(),
            mainTitle: isMerchantAdminLocation() || isOutletAdminLocation(),
            mainDescription: isMerchantAdminLocation()
        };
    };
    const successSaveResponse = () => {
        messageService.saveAlert('Changes saved');
        // this is how merchant and outlet are refreshed at the moment but we should not cache things in this app
        merchantService.refreshMerchantInfo();

        if(isOutletAdminLocation()) {
            outletService.refreshOutletInfo(null);
        }
    };
    const resetDataToDefault = () => {
        vm.integrationData =
            integrationSettingsService.addDefaultValueAndValidate(vm.integrationData, true);
    };
    const sendToExternalForm = () => {
        if (isMerchantCreationLocation()) {
            // pass to the parent
            const integrationData =
                integrationHelperService.convertBackToDomainObject(vm.integrationData);
            vm.onIntegrationDataUpdate({integrationData});
        } else if (isOutletCreationLocation()) {
            const integrationData =
                integrationHelperService.convertBackToDomainObjectOutlet(vm.integrationData);
            vm.onIntegrationDataUpdate({integrationData});
        }
    };
    vm.updatePosType = (posType) => {
        vm.integrationData.posType = posType;
        resetDataToDefault();
        sendToExternalForm();
        if (posType === integrationConstant.POS_TYPE.Comtrex) {
            merchantService.getMerchantComtrexSecurityCode(vm.integrationData.merchantName)
                .then((response) => {
                    vm.integrationData =
                        integrationSettingsService.updateComtrexSecurityCode(vm.integrationData, response);
                })
                .catch(handleError);
        }
    };
    vm.updateIntegrationType = type => {
        vm.integrationData.integration = type;
        resetDataToDefault();
        sendToExternalForm();
    };
    vm.updateData = (dataUpdated) => {
        vm.integrationData = integrationSettingsService.copyWithDefaults(dataUpdated, vm.integrationData);
        sendToExternalForm();
        manageDisplay();
    };
    vm.fullReload = (dataToReload) => {
        vm.integrationData = integrationSettingsService.merge({}, dataToReload);
        sendToExternalForm();
        manageDisplay();
    };
    vm.cleanSubFeature = (data) => {
        const valuesToClean = integrationSettingsService.cleanToggleSubFeaturesWhenOff(data);
        vm.integrationData = integrationSettingsService.copyWithDefaults(valuesToClean, vm.integrationData);
    };
    // merchantCreation and OutletCreation does NOT call save, instead it just append to their forms
    vm.prepareToSave = (isFormInvalid) => {
        if (isFormInvalid) {
            return;
        }
        // TODO revise this and sendToExternalForm, very similar, create a map to return the object to send
        if (isMerchantAdminLocation()) {
            const integrationPosCommand =
                integrationHelperService.convertBackToDomainObject(vm.integrationData, vm.location);
            integrationUnrestService.update(integrationPosCommand)
                .then(successSaveResponse)
                .catch(handleError);
        } else if (isOutletAdminLocation()) {
            const originalDataToSend =
                integrationHelperService.convertBackToDomainObjectOutlet(vm.integrationData);
            outletService.updateIntegrationSettings(originalDataToSend)
                .then(successSaveResponse)
                .catch(handleError);
        }
    };
    vm.$onInit = () => {
        const flattenData = integrationHelperService.convertServerDataToFlatten(vm.originalData);
        vm.integrationData = integrationSettingsService.addDefaultValueAndValidate(flattenData, false);
        if (vm.originalParentData) {
            vm.parentData = integrationHelperService.convertServerDataToFlatten(vm.originalParentData);
        }
        vm.integrationTitle = getTitle();
         // console.log('Original Data * ', vm.originalData)
         // console.log('flattenData * ', vm.integrationData)
         // console.log('PARENT flattenData * ', vm.parentData)
        vm.tooltipMessage = gettextCatalog.getString('There are some fields that are required or invalid');
        manageDisplay();
        if(isMerchantCreationLocation() || isOutletCreationLocation()) {
            sendToExternalForm();
        }
    };
}
angular.module('qkr.integration.settings')
    .component('integrationSettings', {
        template: require('./integration-settings.html'),
        bindings: {
            originalData: '<?',
            originalParentData: '<?',
            location: '<',
            integrationForm: '<',
            outletsSummaryData: '<',
            posPartners:'<',
            onIntegrationDataUpdate: '&?'
        },
        controller: integrationSettings,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/integration.settings.component.js